import React from 'react';
import clsx from 'clsx';
import {
    Backdrop,
    CircularProgress,
    Fade,
    Grid,
    withStyles,
} from '@material-ui/core';

import PropTypes from 'prop-types';
import {InferPropTypes} from 'commons/types/Types';
import {SpinnerStyles} from 'assets/tss/layouts/components';

function EfeSpinner(
    props: InferPropTypes<typeof EfeSpinner.propTypes, typeof SpinnerStyles>
) {
    const {classes, open, message} = props;

    return (
        <div className='Spinner'>
            <Backdrop className={classes.backdrop} open={open}>
                <div>
                    <Grid
                        container
                        spacing={2}
                        alignContent='center'
                        justifyContent='center'
                        direction='row'>
                        <Grid item xs={12} sm={12} md={12} className='d-flex'>
                            <div className='w-100 mx-auto'>
                                <Fade
                                    in={open}
                                    style={{
                                        transitionDelay: open ? '100ms' : '0ms',
                                    }}
                                    unmountOnExit>
                                    <CircularProgress size={'3.5rem'} />
                                </Fade>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        alignContent='center'
                        justifyContent='center'
                        direction='row'>
                        <Grid item xs={12} sm={12} md={12} className='d-flex'>
                            <div className={clsx(classes.label, 'mx-auto')}>
                                <p>{message}</p>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Backdrop>
        </div>
    );
}

EfeSpinner.propTypes = {
    open: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
};

EfeSpinner.defaultProps = {
    message: 'loading...',
};

export default withStyles(SpinnerStyles)(EfeSpinner);
